import { render, staticRenderFns } from "./ArrangeWrapper.vue?vue&type=template&id=141b1d0f&"
import script from "./ArrangeWrapper.vue?vue&type=script&lang=js&"
export * from "./ArrangeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports